export default __webpack_public_path__ + "static/media/67.a941dc1a.png";